import React from 'react';
import DailyReceiptPage from './DailyReceiptPage';

export default function DailyReceiptsHome() {
  return <DailyReceiptPage />;
}
